import {Injectable} from '@angular/core';
import {DialogCloseResult, DialogRef, DialogService} from '@progress/kendo-angular-dialog';
import {NotificationService as KendoNotificationService} from '@progress/kendo-angular-notification';
import { isNullOrUndefined } from 'util';

@Injectable()
export class NotificationService {
    constructor(
        private dialogService: DialogService,
        private notificationService: KendoNotificationService
    ) {

    }

    public confirm(confirmedFn: Function, options?: Object, declinedFn?: Function): DialogRef {
        options = Object.assign({
            title: 'Potwierdzenie',
            content: 'Czy jesteś pewien?',
            actions: [
                {text: 'Nie'},
                {text: 'Tak', primary: true}
            ],
            width: 450,
            height: 200,
            minWidth: 250
        }, options);

        const dialog: DialogRef = this.dialogService.open(options);

        const sub = dialog.result.subscribe((result) => {
            if (result instanceof DialogCloseResult) {

            } else if (result.primary) {
                confirmedFn();
            } else {
                if (isNullOrUndefined(declinedFn) === false) {
                    declinedFn();
                }
            }

            sub.unsubscribe();
        });

        return dialog;
    }

    public success(message: string) {
        this.notification(message, 'success');

    }

    public error(message: string) {
        this.notification(message, 'error');
    }

    private notification(message: string, type: 'none' | 'success' | 'warning' | 'error' | 'info' = 'none') {
        this.notificationService.show({
            content: message,
            type: {
                style: type,
                icon: false
            },
            animation: {
                type: 'slide',
                duration: 400
            },
            position: {
                horizontal: 'center',
                vertical: 'bottom'
            },
        });
    }

    warning(message: string) {
        this.notification(message, 'warning');
    }
}
